import { render } from "./JournalArticle.vue?vue&type=template&id=6a1c2ead"
import script from "./JournalArticle.vue?vue&type=script&lang=js"
export * from "./JournalArticle.vue?vue&type=script&lang=js"

import exportComponent from "/opt/cah/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__